import { Button } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const OnBack = styled(Button)`
  font-size: ${tokens.fontSizes.m};
  line-height: ${tokens.lineHeights.l};
  display: flex;
  align-items: center;
  width: fit-content;
  padding: ${tokens.space.smallest} 0;
  font-family: ${tokens.font.family.ifood.body};

  svg {
    width: ${tokens.space.larger};
    height: ${tokens.space.larger};
    margin-right: ${tokens.space.smaller};
    margin-left: -10px;
  }

  &:focus {
    box-shadow: none;
  }
`;
